<template>
  <el-form ref="personalDetails" :inline="true" :model="personalDetails"
           label-width="124px" :disabled=true size="small">
    <el-form-item label="Επώνυμο">
      {{personalDetails.surname}}
    </el-form-item>
    <el-form-item label="Όνομα">
      {{personalDetails.name}}
    </el-form-item>
    <el-form-item label="Πατρώνυμο">
      {{personalDetails.fatherName}}
    </el-form-item>
    <el-form-item label="Μητρώνυμο">
      {{personalDetails.motherName}}
    </el-form-item>
    <el-form-item label="Φύλο" v-if="activeRole !== 'Auditor'">
      {{personalDetails.gender}}
    </el-form-item>
    <el-form-item label="Φύλο" v-else>
      ***
    </el-form-item>
    <hr>
    <el-form-item label="Χώρα Γέννησης">
      {{birthCountryName}}
    </el-form-item>
    <el-form-item label="Πόλη γέννησης">
      {{personalDetails.birthCity}}
    </el-form-item>
    <el-form-item label="Ημερ. Γέννησης">
      {{personalDetails.dateOfBirth}}
    </el-form-item>
    <hr>
    <el-form-item label="Διεύθυνση" v-if="activeRole !== 'Auditor'">
      {{personalDetails.address}}
    </el-form-item>
     <el-form-item label="Διεύθυνση" v-else>
      *****
    </el-form-item>
    <el-form-item label="Τ.Κ." v-if="activeRole !== 'Auditor'">
      {{personalDetails.postcode}}
    </el-form-item>
    <el-form-item label="Τ.Κ." v-else>
      *****
    </el-form-item>
    <el-form-item label="Περιοχή" v-if="activeRole !== 'Auditor'">
      {{personalDetails.area}}
    </el-form-item>
     <el-form-item label="Περιοχή" v-else>
      *****
    </el-form-item>
    <el-form-item label="Πόλη" v-if="activeRole !== 'Auditor'">
      {{personalDetails.city}}
    </el-form-item>
     <el-form-item label="Πόλη" v-else>
      *****
    </el-form-item>
    <el-form-item label="Χώρα">
      {{countryName}}
    </el-form-item>
    <el-form-item label="Τηλέφωνο">
      {{personalDetails.telephone}}
    </el-form-item>
    <el-form-item label="Κινητό">
      {{personalDetails.mobile}}
    </el-form-item>
    <el-form-item label="email">
      {{personalDetails.email}}
    </el-form-item>
    <el-form-item label="ΑΦΜ">
      {{personalDetails.afm}}
    </el-form-item>
    <hr>
    <el-form-item label="Πιστοποιητικό">
      {{idOrPassport}}
    </el-form-item>
    <el-form-item label="Αριθμός">
      {{personalDetails.id.number}}
    </el-form-item>
    <el-form-item v-show="personalDetails.id.idCardOrPassport" label="Ημερ. Έκδοσης">
      {{personalDetails.id.issueDate}}
    </el-form-item>
    <el-form-item v-show="!personalDetails.id.idCardOrPassport" label="Ημερ. Λήξης">
      {{personalDetails.id.expireDate}}
    </el-form-item>
    <el-form-item v-show="personalDetails.id.idCardOrPassport" label="Εκδoύσα Αρχή">
      {{personalDetails.id.issueAuthority}}
    </el-form-item>
    <el-form-item v-show="!personalDetails.id.idCardOrPassport" label="Χώρα Έκδοσης">
      {{personalDetails.id.issueAuthority}}
    </el-form-item>
    <hr>
  </el-form>
</template>

<script>
// import axios from 'axios'
import { mapGetters, mapState } from 'vuex'
export default {
  props: ['personalDetails'],
  data () {
    return {
    }
  },
  computed: {
    idOrPassport () {
      return this.personalDetails.id.idCardOrPassport ? 'Ταυτότητα' : 'Διαβατήριο'
    },
    birthCountryName () {
      let country = this.countries.find(item => item.id === this.personalDetails.birthCountryId)
      return country !== undefined ? country.name : ''
    },
    countryName () {
      let country = this.countries.find(item => item.id === this.personalDetails.countryId)
      return country !== undefined ? country.name : ''
    },
    ...mapGetters(['activeRole']),
    ...mapState([
      'countries'
    ])
  }
}
</script>

<style scoped lang="scss">
.el-form-item {
  color: rgb(30, 0, 128);
  font-weight: bold;
  // border-radius: 10px;
  // border-style: solid;
  // border-color: #7fa3bb green #86b8da yellow;
  // border-width: 0px 0px 2px 0px;
  // padding-right: 20px;
}
hr {
  border-color: #7da0b8;
}
</style>



// WEBPACK FOOTER //
// src/components/common/PersonalDetails.vue